import React from 'react';
import { Message } from 'semantic-ui-react';
import { isSummaryLog } from '../helpers/logPayload';

export default function RequestLogPayloadNotice({ log }) {
  if (!isSummaryLog(log)) return null;
  return (
    <Message info data-testid='request-log-summary-notice'>
      摘要日志：保留请求追踪信息，不包含完整请求或回答，不能直接用于重放。
      当前未开启原文归档，无法从摘要恢复完整正文。
    </Message>
  );
}
